import { useQuery } from 'react-query'
import { getResendEmail } from 'services/cm-api/get-resend-email'

export function useResendEmail(customerId) {
  return useQuery(['getResendEmail'], () => getResendEmail(customerId), {
    onError: (err) => {
      console.error('getResendEmail failed: ', err)
    },
    enabled: false,
  })
}
